

















































































































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
import 'smartwizard/dist/js/jquery.smartWizard.js';

declare const $: any;

@Component({})
export default class ObjektiCard2Tab9Kategorizacija extends Vue {
  @Prop() store!: {};
  @Prop() storeCategorization1!: [];
  @Prop() storeCategorization2!: [];
  @Prop() storeCategorization3!: [];
  @Prop() storeCategorization4!: [];
  @Prop() storeCategorization5!: [];
  @Prop() storeCategorization6!: [];
  @Prop() storeCategorization8!: [];
  @Prop() storeCategorization9!: [];

  selected = {};

  async mounted() {
    let smartwizard = $('#smartwizard');
    smartwizard.smartWizard({
      selected: 0,
      theme: 'dots',
      justified: true,
      enableURLhash: false,
      autoAdjustHeight: false,
      transition: {
        animation: 'slide-swing'
      },
      toolbarSettings: {
        showNextButton: false,
        showPreviousButton: false,
      }
    });
    let finishBtn = $('#finishButton');
    let nextBtn = $('#nextButton');
    finishBtn.hide();
    smartwizard.on('leaveStep', (e, anchorObject, stepDirection, stepNumber, stepPosition) => {
      if (stepNumber === 2) {
        finishBtn.show();
        nextBtn.hide();
      } else {
        nextBtn.show();
        finishBtn.hide();
      }
    });
  }


  goToFirstStepInWizard() {
    $('#smartwizard').smartWizard("goToStep", 0);
  }

  @Emit() save() {}

}
